import { render, staticRenderFns } from "./AuthHeaderBlock.vue?vue&type=template&id=7972eb7b&"
import script from "./AuthHeaderBlock.vue?vue&type=script&lang=js&"
export * from "./AuthHeaderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports